import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.producto_servicio = {
      ...state.app.catalogos.producto_servicio,
      filters: {
        ...state.app.catalogos.producto_servicio.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.producto_servicio;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/productos-servicios', { params });

    store.setState((state) => {
      state.app.catalogos.producto_servicio = {
        ...state.app.catalogos.producto_servicio,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.producto_servicio.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.producto_servicio.busy = false;
      state.app.catalogos.producto_servicio.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.producto_servicio = {
      ...initialState,
    };
  });
};

const ProductoServicioSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default ProductoServicioSuggestionsStore;
